const getTerminalTypes = () => {
    return new Promise((res, rej) => {
        axios.get("merchant/gettransactiontypes")
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};
const getTerminalTypeByStore = (request) => {
    return new Promise((res, rej) => {
        axios.post("merchant/getstoretransactiontypes", request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};
const setupTerminal = (request) => {
    return new Promise((res, rej) => {
        axios.post('merchant/setupterminal', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};
const getTerminalDetails = (request) => {
    return new Promise((res, rej) => {
        axios.post('merchant/getterminaldetails', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};
const updateTerminal = (request) => {
    return new Promise((res, rej) => {
        axios.post('merchant/updateterminal', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const setTerminalSettings = (request) => {
    return new Promise((res, rej) => {
        axios.post('/merchant/updateterminalsettings', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};


const checkForStoreAccess = (request) => {
    return new Promise((res, rej) => {
        axios.post('merchant/checkstoreaccess', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const saveTipSettings = (request) => {
    return new Promise((res, rej) => {
        axios.put('merchant/terminaltip', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const getAuthorizedTerminals = (request) => {
    return new Promise((res, rej) => {
        axios.post('merchant/getauthorizedterminals', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const swapCameraSettings = (request) => {
    return new Promise((res, rej) => {
        axios.post('/merchant/swapcamera', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const updateTerminalUniqueIdentificationId = (request) => {
    return new Promise((res, rej) => {
        axios.post('merchant/updateterminaluniqueidentificationid', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

export default {
    getTerminalTypes,
    getTerminalTypeByStore,
    setupTerminal,
    getTerminalDetails,
    updateTerminal,
    setTerminalSettings,
    saveTipSettings,
    getAuthorizedTerminals,
    swapCameraSettings,
    updateTerminalUniqueIdentificationId
};